import { useQuery } from '@tanstack/react-query'
import { getPanelsPeopleHierarchy } from '../resources'
import { KEY_PEOPLE_HIERARCHY } from '../keys'

export function useGetPanelsPeopleHierarchy() {
  return useQuery({
    queryKey: [KEY_PEOPLE_HIERARCHY],
    queryFn: getPanelsPeopleHierarchy,
  })
}
